import React from 'react';
import { Container } from 'react-bootstrap';
import './MunicipalidadHeader.css';

const MunicipalidadHeader = ({ tipo, title }) => {
  var style =
    tipo == 'Gobierno'
      ? {
          backgroundImage: 'url("/assets/images/interna-gobierno.jpg")',
        }
      : {
          backgroundImage: 'url("/assets/images/interna-ciudadano.jpg")',
        };
  return (
    <>
      <div className="header-back" style={style}></div>
      <Container className="header-title">
        <h2>{title}</h2>
      </Container>
    </>
  );
};

export default React.memo(MunicipalidadHeader);
